import { useEffect } from 'react'

export function useVisualViewportHeight() {
  useEffect(() => {
    const updateVh = () => {
      const vv = window.visualViewport
      const vh = vv?.height ?? window.innerHeight
      // How far iOS Safari has scrolled the page to keep a focused field above
      // the keyboard. A `position: fixed` element doesn't follow this scroll, so
      // we expose it and let the page offset itself to avoid a black gap above
      // the keyboard.
      const offsetTop = vv?.offsetTop ?? 0
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--vh-offset', `${offsetTop}px`)
    }

    updateVh()

    const vv = window.visualViewport
    vv?.addEventListener('resize', updateVh)
    // offsetTop changes on scroll without a resize, so we must track scroll too.
    vv?.addEventListener('scroll', updateVh)
    window.addEventListener('resize', updateVh)

    return () => {
      vv?.removeEventListener('resize', updateVh)
      vv?.removeEventListener('scroll', updateVh)
      window.removeEventListener('resize', updateVh)
    }
  }, [])
}
